import { CoreDocumentType, CoreDocumentTypeItem } from '../modules/documents';
import { APIDocumentSearchResult } from '../types/api';

type SortType = (
  a: APIDocumentSearchResult,
  b: APIDocumentSearchResult,
) => number;

export const buildDocumentsTree = (
  items: APIDocumentSearchResult[],
  parentId: null | string = null,
  sortFn: SortType = (a, b) => a.document.position - b.document.position,
) => {
  return items
    .filter((item) => item.document.parentId === parentId)
    .sort(sortFn)
    .map((item) => {
      const children: CoreDocumentTypeItem[] = buildDocumentsTree(
        items,
        item.document.id,
        sortFn,
      );
      return {
        id: item.document.id,
        name: item.document.title,
        isCategory: item.document.isCategory,
        document: item.document,
        children: [...(children.length ? children : [])],
      };
    });
};

export const flattenDocumentTree = (
  array: (CoreDocumentType & { children?: CoreDocumentType[] })[],
): CoreDocumentType[] =>
  array.flatMap(({ id, name, isCategory, document, children }) => [
    { id, name, isCategory, document },
    ...flattenDocumentTree(children || []),
  ]);
